var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{on:{"click":_vm.openModal}},[_c('LazyPhoto',{staticClass:"hover",attrs:{"src":_vm.src}})],1),_c('b-modal',{attrs:{"size":"lg","id":_vm.title,"title":_vm.title,"ok-only":""}},[_c('div',{staticClass:"image"},[_c('LazyPhoto',{staticClass:"hover",attrs:{"src":_vm.src}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }